export default {
    USER_ID: `user_kBwtp0UPon3Xjy3NAI3Bv`, //userID
    TEMPLATE_ID: `template_6ce837d`,         //templateID
}